import api from '../api/client';

const catalogoConfigService = {
  // Buscar configuração do catálogo
  getConfig: async (organizadorId) => {
    try {
      const response = await api.get(`/organizadores/${organizadorId}/catalogo-config`);
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        // Retorna configuração padrão se não existir
        return {
          colunas_ativas: ['lote', 'vendedor', 'quantidade', 'tipo', 'raca', 'sexo', 'idade', 'peso', 'curral'],
          lotes_por_pagina: 32,
          mostrar_totais: true,
          mostrar_rodape: true,
          ocultar_total_animais: false,
          regulamento_habilitado: false,
          regulamento_texto: null,
          observacao_sempre_abaixo: false,
          obs_ocultar_linha_abaixo: false,
          ajuste_automatico_colunas: false,
          espacamento_linha: 'normal'
        };
      }
      throw error;
    }
  },

  // Salvar configuração do catálogo
  saveConfig: async (organizadorId, config) => {
    const response = await api.post(`/organizadores/${organizadorId}/catalogo-config`, config);
    return response.data;
  },

  // Atualizar configuração do catálogo
  updateConfig: async (organizadorId, config) => {
    const response = await api.put(`/organizadores/${organizadorId}/catalogo-config`, config);
    return response.data;
  }
};

export default catalogoConfigService;
